"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _isNaN = _interopRequireDefault(require("lodash/isNaN"));
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var _isBoolean = _interopRequireDefault(require("lodash/isBoolean"));
var _get = _interopRequireDefault(require("lodash/get"));
var _DebounceHook = _interopRequireDefault(require("../DebounceHook"));
var _BrixelTooltip = _interopRequireDefault(require("../BrixelTooltip"));
var _BrixelIcon = _interopRequireDefault(require("../BrixelIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelRadioButton = props => {
  const {
    disabled = false,
    className = '',
    deactivable = true,
    disableDelay = false,
    icons = false,
    input,
    inputClassName = '',
    isHorizontal = false,
    label = '',
    modal = null,
    options,
    pdClass = '',
    validation = false,
    cardLayout = false,
    cardSmall = false,
    svgSupport = false,
    stretched = false,
    svgWidth = '',
    large = false,
    setValue,
    tooltip,
    bulletPoints
  } = props;
  const [currentValue, setCurrentValue] = (0, _react.useState)(input.value);
  const debouncedSearchTerm = (0, _DebounceHook.default)(currentValue, disableDelay ? 0 : 500);
  const [onHoverImg, setOnHoverImg] = (0, _react.useState)([...Array(options.length)]);
  (0, _react.useEffect)(() => {
    if (input.onChange && input.value !== currentValue && !disableDelay && options.length > 0) {
      input.onChange(debouncedSearchTerm);
    }
  }, [debouncedSearchTerm]);
  (0, _react.useEffect)(() => {
    if (input.onChange && input.value !== currentValue && disableDelay && options.length > 0) {
      input.onChange(currentValue);
    }
  }, [currentValue]);
  (0, _react.useEffect)(() => {
    if (input.value !== currentValue) {
      setCurrentValue(input.value);
    }
  }, [input.value]);
  const clickOption = e => {
    if (deactivable) {
      if (input.value && (e.target.value === input.value || e.target.value === input.value.toString() || +e.target.value === +input.value)) {
        setCurrentValue(null);
        if (setValue) setValue(null);
        if (input.onChange) input.onChange(e.target.value);
      }
    }
  };
  const onChange = val => {
    let value;
    switch (val) {
      case (0, _isBoolean.default)(val):
        value = Boolean(val);
        break;
      case !(0, _isNaN.default)(val):
        value = +val;
        break;
      default:
        value = val;
    }
    if (setValue) setValue(value);
    setCurrentValue(value);
  };
  const curVal = currentValue;
  const hoverImg = (index, hover) => {
    const imgList = (0, _cloneDeep.default)(onHoverImg);
    imgList[index] = hover;
    setOnHoverImg(imgList);
  };
  const OptionsComponent = (val, i) => {
    const {
      backIcon,
      color,
      icon,
      img,
      index,
      title,
      value
    } = val;
    const optionLabel = (0, _get.default)(val, 'label', '');
    let wrapClass = '';
    if (pdClass === '' && icons) wrapClass = 'p-2';else wrapClass = pdClass || '';
    // eslint-disable-next-line react/destructuring-assignment
    const key = i.toString();
    const indexKey = index || i;
    const colorMarker = (0, _get.default)(input, 'checkmarkColor', '') || '';
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `${icons ? 'brixel-radio-button-icon' : 'brixel-radio-button'} ${inputClassName} ${isHorizontal ? `${cardLayout ? 'ml-a mr-a mr-small-sm-12 ml-small-sm-12' : 'mr-2'}` : 'mt-2'} ${cardLayout ? `${cardSmall ? 'cardSmall' : ''} w-perc-100` : ''}`,
      key: key,
      onMouseEnter: () => hoverImg(i, true),
      onMouseLeave: () => hoverImg(i, false)
    }, /*#__PURE__*/_react.default.createElement("input", {
      role: "radio",
      "data-validation": validation,
      type: "radio",
      id: `${(0, _get.default)(input, 'name')}_${indexKey}`,
      value: value,
      name: (0, _get.default)(input, 'name'),
      checked: value === curVal,
      onChange: () => onChange(value),
      onClick: e => clickOption(e),
      disabled: disabled
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: `${disabled ? 'disabled' : ''} ${value === curVal ? 'checked' : ''} ${wrapClass} ${cardLayout && window.innerWidth < 590 ? 'dis-fl-col row-reverse' : ''} ${cardLayout && window.innerWidth >= 590 ? 'dis-fl-col col-reverse' : ''} ${color || ''} ${svgSupport && (onHoverImg[i] || value === curVal) ? 'onHover' : ''}`,
      htmlFor: `${(0, _get.default)(input, 'name')}_${indexKey}`
    }, icons ? (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      // eslint-disable-next-line no-nested-ternary
      className: `${cardLayout && window.innerWidth < 590 ? !img ? 'col-reverse a-t pl-2' : 'row-reverse jc-b' : ''} ${cardLayout && window.innerWidth >= 590 ? 'col-reverse jc-c ta-c' : ''} ${cardLayout ? 'dis-fl-col a-c w-perc-100' : 'dis-f a-c'}`
    }, icon && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
      color: backIcon || 'primary',
      saturationTxt: 700,
      background: backIcon || 'primary',
      saturation: 200,
      icon: icon
    })), cardLayout ? (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, img && (/*#__PURE__*/_react.default.createElement("div", {
      className: `iconHolder ${svgWidth ? `${svgWidth}` : `${cardSmall ? '' : ''} `}`
    }, svgSupport ? (/*#__PURE__*/_react.default.createElement("div", {
      className: "svg-container",
      dangerouslySetInnerHTML: {
        __html: img
      }
    })) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, img && (/*#__PURE__*/_react.default.createElement("img", {
      src: img,
      alt: label
    })))))))) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, img && (/*#__PURE__*/_react.default.createElement("img", {
      className: "",
      src: img,
      alt: optionLabel
    })))), /*#__PURE__*/_react.default.createElement("span", {
      // eslint-disable-next-line no-nested-ternary
      className: `textLabel ${large ? 'labelLarge' : ''} ${cardLayout ? `a-c ta-c-sm ${stretched ? 'max-w-fix-240' : 'max-w-fix-184'}` : ''} ${cardLayout && window.innerWidth >= 590 ? 'pt-2 pb-4' : !img ? 'pl-0' : 'pl-2'} ${!img ? '' : 'pl-1'} pl-md-0`,
      dangerouslySetInnerHTML: {
        __html: optionLabel
      }
    }), title && (/*#__PURE__*/_react.default.createElement("b", {
      className: `dis-b fweight-600 fsize-500 ${!img ? 'py-1' : 'pt-2'}`
    }, title))), /*#__PURE__*/_react.default.createElement("span", {
      className: `checkmark ${colorMarker}`
    }))) : (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: `checkmark ${colorMarker}`
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "radioBtnLabel",
      dangerouslySetInnerHTML: {
        __html: optionLabel
      }
    })))));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: `${cardLayout ? 'cardLayout' : ''} ${cardSmall ? 'cardSmall' : ''} ${icons ? '' : 'brixel-radio-button-wrapper'} ${bulletPoints ? 'wBulletPoints' : ''} ${className}`
  }, label && (/*#__PURE__*/_react.default.createElement("div", {
    className: (0, _get.default)(modal, 'info', null) ? 'mb-1' : ''
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: `brixel-label ${(0, _get.default)(modal, 'info', null) ? 'noPadd' : ''} ${large ? 'labelLarge' : ''}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `va-tb ${tooltip ? 'mr-1' : ''}`
  }, label), !tooltip && modal && (0, _get.default)(modal, 'info', null) && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    onClick: e => modal.func ? modal.func(e) : '',
    className: "ml-2 pt-small-2",
    icon: "info",
    color: "primary"
  })), tooltip && !modal && (/*#__PURE__*/_react.default.createElement(_BrixelTooltip.default, {
    className: "dis-ib",
    label: tooltip.label,
    width: tooltip.width,
    description: tooltip.description,
    theme: tooltip.theme
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: `w-perc-100 ${cardLayout ? 'jc-c' : ''} ${isHorizontal ? 'dis-fl-row' : 'dis-fl-col'} ${cardLayout && window.innerWidth < 590 ? 'flex-wrap' : ''}`
  }, options.map((val, i) => (/*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: `opt_${i.toString()}`
  }, OptionsComponent(val, i))))), modal && !(0, _get.default)(modal, 'info', null) && modal.message && (/*#__PURE__*/_react.default.createElement("span", {
    onClick: e => modal.func ? modal.func(e) : '',
    className: `message ${modal.func ? 'cur-poi' : ''} ${modal.className || ''}`,
    dangerouslySetInnerHTML: {
      __html: modal.message || ''
    }
  })), bulletPoints && !modal && (/*#__PURE__*/_react.default.createElement("div", {
    className: "dis-fl-col"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "mb-2"
  }, bulletPoints.title), /*#__PURE__*/_react.default.createElement("ul", null, bulletPoints.description?.map((bullet, k) => (/*#__PURE__*/_react.default.createElement("li", {
    className: "mb-2",
    key: k.toString()
  }, bullet))))))));
};
var _default = exports.default = BrixelRadioButton;